import { API } from "../config";

export const submitProofData = (id,data, token) =>{
    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/wallet/submit-proof/${id}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
}

export const submitProofImage = (id, data) =>{
    const formData = new FormData();
    formData.append('file', data);

    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/wallet/submit-proof/image/${id}`, {
        method: "PUT",
        body: formData
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
}

export const createPaymentIntents = (data, token) =>{

    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/paymongo/payment_intents`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
}

export const createPaymentMethod = (data, token) =>{
    
    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/paymongo/payment_methods`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
}

export const attachPaymentIntents = (data, token) =>{
    
    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/paymongo/payment_intents/attach`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
}

export const storeUserBalance = ( id,data, token) => {
    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/wallet/top-up/user-balance/${id}` , {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
}

export const getUserBalance = (id, token) => {
    return fetch(`${(process.env.REACT_APP_API_URL) ? `${API}` : '/api'}/wallet/top-up/user-balance/${id}` , {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
        return response.json();
    })
    .catch(err => console.log(err));
}
